var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_core.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_core.js
// module chunks = 6